export default [
  {
    path: '/myCardList',
    name: 'MyCardList',
    component: () => import('@/views/cardManage/myCardList.vue'),
  },
  {
    path: '/cardDetail',
    name: 'CardDetail',
    component: () => import('@/views/cardManage/cardDetail.vue'),
  },
]
